<style scoped>

  .content {
    padding: 5px 20px 20px 20px !important;
  }

</style>

<template>

  <div class="ui fluid styled accordion">

    <div id="filters-button" class="title" :class="{ active }">
      <i class="dropdown icon"></i>
      Filtros
    </div>

    <div class="content" :class="{ active }">

      <form class="ui form" @submit.prevent="onSearch()" :class="{ loading }">
        <div class="fields">                    
          <div class="ten wide field">
            <label class="form-label">Cliente <span class="red text">*</span></label>
            <input type="text" placeholder="Código, CNPJ ou Razão Social" v-model="filter.keyWord">
          </div>
          <div class="six wide field">
            <label class="form-label">Segmento <span class="red text">*</span></label>
            <select id="select-segment" class="ui fluid search dropdown" v-model="filter.segment">
              <option value="*">Todos</option>
              <option v-for="segment in $store.state.segments" :value="segment.id">{{ segment.name }}</option>
            </select>
          </div>
        </div>                              
        <button class="ui basic blue icon button" :class="{ loading: searching }" 
          type="submit" style="margin-top: 10px;">
          <i class="search icon"></i>
          Pesquisar
        </button>
      </form>

    </div>

  </div>

</template>

<script>

  import Message from "@/utils/message"
  import CustomerService from "@/services/customer-service"

  export default {

    data() {
      return {
        loading: true,
        filter: {          
          keyWord: "",
          segment: "*",
          showBlocked: true,
        },        
      }
    },

    props: ["active", "searching"],

    mounted() {

      $(".accordion").accordion()                  

      $(".form-dropdown").dropdown({
        fullTextSearch: true,
      })

      this.loadData()
    },

    methods: {

      async loadData() {

        this.loading = true

        try {        

          if (this.$store.state.segments.length == 0)
            this.$store.commit("setSegments", await CustomerService.getSegments())

          if (this.$store.state.customersFilter)
            this.filter = this.$cloneObject(this.$store.state.customersFilter)      

          $("#select-segment").dropdown("set selected", this.filter.segment)
          
          this.loading = false
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },      

      onSearch() {    

        if (this.filter.segment == "*" && this.filter.keyWord.length < 4) {
          Message.info("Informe ao menos 4 caracteres para pesquisa")
          return
        }

        let data = this.$cloneObject(this.filter)

        this.$store.commit("setCustomersFilters", data)

        if (data.segment == "*")
          data.segment = "" 

        this.$emit("onSearch", data)
      },

      toggleActive() {
        $("#filters-button").click()
      },
    },
  }

</script>
